import { useState, useEffect, useCallback } from "react";
import useApi from "./apiService";

export const CARD_STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  ERROR: "error",
  EMPTY: "empty",
  READY: "ready",
  WAITING_GENERATION: "waiting_generation",
};

const useDinamometricCard = (assetId) => {
  const { fetchData } = useApi();
  const [status, setStatus] = useState(CARD_STATUS.IDLE);
  const [cardData, setCardData] = useState(null);
  const [hasNewCard, setHasNewCard] = useState(false);
  const [requesting, setRequesting] = useState(false);

  const fetchLatestCard = useCallback(async () => {
    if (!assetId) return;
    setStatus(CARD_STATUS.LOADING);
    setCardData(null);
    try {
      const response = await fetchData(
        `/dynamometer-cards/assets/${assetId}?page=1&items_per_page=1`,
      );
      const items = response.data;
      if (!items || items.length === 0) {
        setStatus(CARD_STATUS.EMPTY);
      } else {
        setCardData(items[0]);
        setStatus(CARD_STATUS.READY);
      }
    } catch {
      setStatus(CARD_STATUS.ERROR);
    }
  }, [assetId]);

  useEffect(() => {
    fetchLatestCard();
  }, [fetchLatestCard]);

  const handleMqttNotification = useCallback(() => {
    setHasNewCard(true);
  }, []);

  const requestCardGeneration = useCallback(async () => {
    if (!assetId || requesting) return;
    setRequesting(true);
    try {
      await fetchData(`/assets/${assetId}/request-dynamometer-card`, {});
    } catch {
      // mantém status atual para o usuário poder tentar novamente
    } finally {
      setRequesting(false);
    }
  }, [assetId, requesting]);

  const refreshCard = useCallback(async () => {
    setHasNewCard(false);
    await fetchLatestCard();
  }, [fetchLatestCard]);

  return {
    status,
    cardData,
    hasNewCard,
    requesting,
    fetchLatestCard,
    requestCardGeneration,
    refreshCard,
    handleMqttNotification,
  };
};

export default useDinamometricCard;
